/**
 @ngdoc directive
 @name preventSubmissionOnEnter

 @description
 Intercepts key events on form elements to stop the enter key triggering a form submission.

 @usage
 <form type="text" prevent-submission-on-enter></form>
 */

(function () {
  "use strict";
  var preventSubmissionOnEnter = function () {
    return {
      restrict: "A",
      link: function ($scope, $element) {
        angular.element($element[0])[0].onkeypress = (e) => {
          const key = e.charCode || e.keyCode || 0;
          // We want to preserve the event if the current target is a textarea otherwise we can't add linebreaks in text areas.
          if (key === 13 && !e.target.matches("textarea")) {
            e.preventDefault();
          }
        };
      },
    };
  };

  angular
    .module("app")
    .directive("preventSubmissionOnEnter", preventSubmissionOnEnter);
})();
